module.exports = __webpack_public_path__ + "media/images/riders/small/SINA_FREI-53fc37aad94cdd2036f2dfa30e4eedb2.png";